


























import { Component, Prop, Emit, Ref } from 'nuxt-property-decorator'
import { find } from 'lodash'
import { ComponentVue } from '@/base'
import { AtomTextField } from '@/components/atoms'
import {
  defaultSystemCodeWithKey,
  SystemCodeWithKey
} from '@/api/models/system-code/SystemCodeWithKey'
import { SystemCode, systemCodeApi } from '@/api'

@Component({
  components: {}
})
export default class InputCodeName extends ComponentVue {
  @Ref()
  textField!: AtomTextField

  @Prop({ type: String, required: true })
  codeKey!: string

  @Prop({ type: String })
  label!: string

  @Prop({ type: String })
  placeholder!: string

  @Prop({ type: String })
  value!: string

  @Prop({
    type: Boolean,
    default: false
  })
  hideName!: boolean

  @Prop({ type: Boolean, default: false })
  clearable!: boolean

  @Prop({
    type: Boolean,
    default: true
  })
  hideDetails!: boolean

  @Prop({ type: Array })
  rules!: any

  @Prop({ type: Boolean, default: false })
  erasable!: boolean

  @Prop({ type: Boolean, default: false })
  erase!: boolean

  @Prop({ type: Boolean, default: false })
  error!: boolean

  @Prop({ type: String, default: '' })
  errorMessage!: string

  @Prop({
    type: Boolean,
    default: false
  })
  flat!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  outlined!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  autofocus!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  disabled!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  multiple!: boolean

  systemCode: SystemCodeWithKey = defaultSystemCodeWithKey()

  systemCodeFetched: boolean = false

  get name(): string {
    if (!this.codeKey || this.hideName || this.multiple) {
      return ''
    }

    const item = find<SystemCode>(this.systemCode.codes, {
      codeKey: this.codeKey,
      code: this.value
    })

    return item ? item.shortName || '' : ''
  }

  onInput(value: string) {
    this.$emit('input', value)
  }

  created() {
    this.fetchSystemCode()
  }

  activated() {
    this.fetchSystemCode()
  }

  deactivated() {
    this.systemCodeFetched = false
  }

  async fetchSystemCode() {
    if (!this.systemCodeFetched) {
      this.systemCodeFetched = true
      this.systemCode = await systemCodeApi.getSystemCodeWithKey(this.codeKey)
    }
  }

  onChange(value: string) {
    this.$emit('change', value)
  }

  onListClick(): void {
    this.$modalCode.open({
      codeKey: this.codeKey,
      title: this.systemCode.name,
      defaultCode: this.value ?? '',
      systemCodes: this.systemCode.codes,
      onOkClick: (item: SystemCode | null) => {
        if (item !== null) {
          this.$emit('input', item.name)
          this.$emit('change', item.code)
        }
      }
    })
  }

  @Emit('click:erase')
  onEraseButtonClick() {}

  @Emit('keydown:enter')
  onKeydownEnter() {}
}
